import styled from 'styled-components';
import { CtaButton } from '../common-components/CtaButton';
import { HtmlZone } from '../common-components/HtmlZone';

export const WelcomeGameCtaButton = styled(CtaButton)`
  bottom: none;
  top: 52vh;
  height: 6vh;
  left: 26vw;
  right: 26vw;
`;
WelcomeGameCtaButton.displayName = 'WelcomeGameCtaButton';

export const WelcomeGameHtmlZone = styled(HtmlZone)`
  bottom: none;
  height: 44vh;
`;
WelcomeGameHtmlZone.displayName = 'WelcomeGameHtmlZone';

export const WelcomeGameDisplaySection = styled.div`
  position: absolute;
  top: 66vh;
  bottom: 5vh;
  left: 5vw;
  right: 5vw;
`;
WelcomeGameDisplaySection.displayName = 'WelcomeGameDisplaySection';

export const WelcomeGameTxt = styled(HtmlZone)`
  height: 3vh;
  top: 0;
  left: 0;
  right: 0;
  justify-content: left;
`;
WelcomeGameTxt.displayName = 'WelcomeGameTxt';

export const WelcomeGameImgSection = styled.div`
  position: absolute;
  top: 5vh;
  width: 100%;
`;
WelcomeGameImgSection.displayName = 'WelcomeGameImgSection';

export const WelcomeGameThumbnail = styled.img`
  width: 100%;
  border-radius: 1vw;
`;
WelcomeGameThumbnail.displayName = 'WelcomeGameThumbnail';

export const SliderArrow = styled.button`
  svg {
    width: 100%;
    height: 100%;
    fill: none;
  }
  background: transparent;
  opacity: 1;
  width: auto;
  height: 6vh;
  &:disabled {
    visibility: hidden;
  }
`;
WelcomeGameThumbnail.displayName = 'SliderArrow';

export const LeftSliderArrow = styled(SliderArrow)`
  left: -1.5vw;
`;
WelcomeGameThumbnail.displayName = 'LeftSliderArrow';

export const RightSliderArrow = styled(SliderArrow)`
  right: -1.5vw;
`;
WelcomeGameThumbnail.displayName = 'RightSliderArrow';
